<template>
  <v-dialog v-model="dialog" width="500">
    <v-card>
    <v-card-title>{{ $t("competition.title") }}</v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-select :items="this.$store.getters.competitions" v-model="selectedCompetition" item-text="title" item-value="id" />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="this.save" color="success">
          {{ $t("ctrl.select") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardActions,
    VCardText,
    VSelect,
    VDatePicker,
    VMenu,
    VIcon,
    VTextarea,
    VDataTable,
    VAutocomplete,
    VCheckbox,
    VAlert,
    VDialog
  } from 'vuetify/lib'
  import fccapi from '../fccapi.js'

  export default {
    name: 'CompetitionDialog',
    data: () => ({
      dialog: false,
      selectedCompetition: null,
    }),
    computed: {
      rules: function() {
        return {
          required: value =>  !!value || this.$t('registration.required')
        }
      }
		},
		props: {
      reload: Function,
      callback: Function
		},
    components: {
      VCard,
      VTooltip,
      VForm,
      VTextField,
      VCardActions,
      VCardText,
      VSelect,
      VIcon,
      VDatePicker,
      VMenu,
      VDataTable,
      VTextarea,
      VAutocomplete,
      VCheckbox,
      VAlert,
      VDialog
    },
    methods: {
      show: function(){
        this.dialog = true;
      },
      save: function(){
        this.callback(this.selectedCompetition);
        this.dialog = false;
      }
    }
  }
</script>